export const CONTENT_TYPE_HEADER = 'Content-Type';
